import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white px-6 pt-6 h-screen pb-52 lg:h-[calc[100vh_-_100px]] overflow-y-auto" }
const _hoisted_2 = { class: "custom-full" }
const _hoisted_3 = { class: "bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px]" }
const _hoisted_4 = { class: "mb-3 flex justify-between" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = {
  key: 1,
  class: "bg-[#2B2C32] border-0 rounded-lg"
}
const _hoisted_7 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass('w-full hidden-component')
}
const _hoisted_8 = { class: "text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden w-full" }
const _hoisted_9 = { class: "bg-[#464851] px-[16px] py-[16px] rounded-lg" }
const _hoisted_10 = { class: "flex justify-center relative gap-3 pb-5" }
const _hoisted_11 = { class: "px-[16px] py-[16px] bg-[#2B2C32] rounded-xl" }
const _hoisted_12 = { class: "flex flex-col justify-center" }
const _hoisted_13 = { class: "flex justify-center mt-4" }
const _hoisted_14 = { class: "flex justify-center items-center pt-[10px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_block_loading = _resolveComponent("block-loading")!
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_List = _resolveComponent("List")!
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass('flex content-main gap-5 ' + (_ctx.action.component ? ' half-it' : ''))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Nav),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_block_loading, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.hasLoyaltyProgramAndCategory)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-[24px] text-white font-semibold" }, "FAQ", -1)),
                        _createElementVNode("div", _hoisted_5, [
                          (_ctx.can_edit_membership_details)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.syncConfirm.modal = true), ["prevent"])),
                                class: "bg-white boder border-theme-green rounded px-4 mr-3 text-theme-green hover:text-white hover:bg-theme-green"
                              }, "RESET FAQ"))
                            : _createCommentVNode("", true),
                          (!_ctx.action.component && _ctx.can_edit_membership_details)
                            ? (_openBlock(), _createBlock(_component_mdicon, {
                                key: 1,
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addUpdate({ component: 'Add', data: {} }))),
                                size: "32",
                                name: "plus",
                                class: "text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode(_component_List, {
                        selectedCallback: _ctx.selectedItem,
                        loyaltyProgram: _ctx.loyaltyProgram,
                        faqCategory: _ctx.faqCategory,
                        clearComponent: _ctx.clearComponent,
                        iscomponentactive: _ctx.action.component ? true : false
                      }, null, 8, ["selectedCallback", "loyaltyProgram", "faqCategory", "clearComponent", "iscomponentactive"])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("div", { class: "mb-3 flex justify-between" }, [
                        _createElementVNode("h3", { class: "text-[20px] text-theme-878686 font-bold tracking-wider" }, "F.A.Q")
                      ], -1),
                      _createElementVNode("p", { class: "text-sm" }, " Loyalty Program is inactive or not set.", -1)
                    ]))]))
              ], 64))
        ])
      ]),
      (_ctx.action.component)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.action.component), {
              loyaltyProgram: _ctx.loyaltyProgram,
              faqCategory: _ctx.faqCategory,
              item: _ctx.action.data,
              clearComponent: _ctx.clearComponent
            }, null, 8, ["loyaltyProgram", "faqCategory", "item", "clearComponent"]))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.syncConfirm.modal)
      ? (_openBlock(), _createBlock(_component_custom_modal, {
          key: 0,
          size: 'max-w-2xl'
        }, {
          maincontent: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-2xl font-normal tracking-wide text-center pr-[40px]" }, "Are you sure you want to reset the FAQ?", -1)),
                  _createElementVNode("a", {
                    href: "",
                    class: "right-0 top-1 absolute",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.syncConfirm.modal = false), ["prevent"]))
                  }, [
                    _createVNode(_component_mdicon, {
                      size: "30px",
                      class: "cursor-pointer hover:text-slate-200",
                      name: "close"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm text-center leading-5 tracking-wider" }, "By confirming this action, you will be resetting your FAQ to default questions and answers. This action is irreversible and you won’t be able to recover your existing questions and answers", -1)),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.syncfaqs()), ["prevent"])),
                        class: "uppercase rounded-lg bg-theme-green hover:bg-theme-darkgreen text-white min-w-[320px] py-[14px] text-sm tracking-wider font-medium"
                      }, "confirm")
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.syncConfirm.modal = false), ["prevent"])),
                    class: "uppercase text-sm font-medium tracking-widest text-white hover:text-theme-green"
                  }, "Close")
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}